/* eslint-disable angular/ng_angularelement */
import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalVideo from '../../shared/components/modal-video/modal-video.view.html';
import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';
import modalRecommendProduct from '../../shared/components/modal-recommend-product/modal-recommend-product.view.html';

let inject = [
  '$scope',
  'CategoryService',
  '$state',
  '$rootScope',
  'SharedService',
  '$stateParams',
  '$uibModal',
  'ProductDetailService',
  '$timeout',
  'CatalogService',
  'CartService'
];

class ProductDetailController{
  constructor ($scope,
               CategoryService,
               $state,
               $rootScope,
               SharedService,
               $stateParams,
               $uibModal,
               ProductDetailService,
               $timeout,
               CatalogService,
               CartService) {
    this.$state = $state;
    this.$scope = $scope;
    this.CatalogService = CatalogService;
    this.ProductDetailService = ProductDetailService;
    this.$stateParams = $stateParams;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.CartService = CartService;
    this.CategoryService = CategoryService;
    this.SharedService = SharedService;
    this.$timeout = $timeout;
    this.loanding = false;
    this.showProductPrice = true;
    this.partSuppliesProduct = [];
    this.featuredProducts = [];
    this.active = 0;
    this.partSustitutesProduct = [];
    this.showBottomAddCart = true;
    this.productQuantity = 1;
    this.productId = this.$stateParams.productId || '';
    this.productSlug = this.$stateParams.productSlug || '';
  }

  $onInit(){
    this.getProductDetail();
    this.getFeaturedProducts();
    this.getRelatedProducts();
  }
  
  updateFavoriteProducts (product) {
    product.isSettingAsFavorite = true;
    let userId = '';
    try{ userId = this.shCtrl.globals.currentUser.userId; }
    catch(e){}
    if(userId) {
      let data = {
        'productId': product.id,
        'userId': userId,
        'setFavorite': !product.isFavorite
      };
      this.CatalogService.updateFavoriteProducts(data).then(response => {
        product.isFavorite = !product.isFavorite;
        product.isSettingAsFavorite = false;
      }).catch(error => {
        product.isSettingAsFavorite = false;
        let options = {
          title : '',
          isHtml : false,
          content : 'Ha ocurrido un error al actualizar el producto',
          size : '',
          showBottonCancel : false,
          textActionCancel : '',
          textAction : 'Aceptar'
        };
        this.messageResponse(options);
      });
    }
  }

  getProductDetail () {
    this.loadingProductDetail = true;
    let userId = '';
    try {userId = this.shCtrl.globals.currentUser.userId;} catch (e) {}
    this.ProductDetailService.getProductDetail(this.productId, this.productSlug, userId).then(response => {
      this.loadingProductDetail = false;
      try {
        this.productDetail = response;
        this.productoPlantilla = response;
        this.initPluginsProductDetails();

        if (this.productDetail.clonedAttributesDetail.length > 0) {
          this.showProductPrice = false;
        }

        if (this.productDetail.isTemplate) {
          this.productTemplateCopy = angular.copy(this.productDetail);
        }
      }
      catch (e) {
        this.$state.go('/404');
      }
    }).catch(reason => {
      this.$state.go('/404');
    });
  }
  
  setItemToAddToCart(product) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalQuantityCart,
      controller : 'ModalQuantityCartController',
      controllerAs : 'mdCtrl',
      size: 'sm',
      resolve : {
        product : () => product
      }
    });
    modalInstance.result.then(result => {
      if(result.product.id && result.quantity){
        let userId = '', cart = null;
        try {userId = this.shCtrl.globals.currentUser.userId;}catch (e) {}
        try {cart = this.shCtrl.cart;}catch (e) {}
        this.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(response => {
          if (!response.error) {
            this.$scope.$emit('onUpdateCart');
            let modalInstance2 = this.$uibModal.open({
              animation: true,
              template: modalConfirmationCart,
              controller : 'ModalConfirmationController',
              controllerAs : 'mdCtrl',
              size: 'lg',
              resolve : {
                product : () => product
              }
            });
          } else {
            let options = {
              title : '',
              isHtml : true,
              content : response.message,
              size : '',
              showBottonCancel : false,
              textActionCancel : '',
              textAction : 'Aceptar'
            };
            this.messageResponse(options);
          }
        }).catch(reason => {
          let options = {
            title : '',
            isHtml : false,
            content : reason,
            size : '',
            showBottonCancel : false,
            textActionCancel : '',
            textAction : 'Aceptar'
          };
          this.messageResponse(options);
        });
      }
    }).catch(error => {
    
    });
  }
  
  getRelatedProducts() {
    this.loadingRelatedProducts = true;
    let userId = '';
    try {userId = this.shCtrl.globals.currentUser.userId;} catch (e) {}
    this.ProductDetailService.getRelatedProducts(this.productId, userId, this.productSlug).then(response => {
      this.relatedProducts = response;
      response.forEach(item => {
        if (item.id_tipo_relacion == '1' || item.id_tipo_relacion == '3') {
          this.partSuppliesProduct.push(item);
        }
    
        if (item.id_tipo_relacion == '2') {
          this.partSustitutesProduct.push(item);
        }
      });
      this.loadingRelatedProducts = false;
    }).catch(reason => {
    
    })
  }

  addItemToCart(product, quantity){
    if(product.id && quantity){
      let userId = '', cart = null;
      try {userId = this.shCtrl.globals.currentUser.userId;}catch (e) {}
      try {cart = this.shCtrl.cart;}catch (e) {}
      this.CartService.addItemToCart(product, quantity, null, null, userId, cart).then(response => {
        if (!response.error) {
          this.$scope.$emit('onUpdateCart');
          let modalInstance2 = this.$uibModal.open({
            animation: true,
            template: modalConfirmationCart,
            controller : 'ModalConfirmationController',
            controllerAs : 'mdCtrl',
            size: 'lg',
            resolve : {
              product : () => product
            }
          });
        } else {
          let options = {
            title : '',
            isHtml : true,
            content : response.message,
            size : '',
            showBottonCancel : false,
            textActionCancel : '',
            textAction : 'Aceptar'
          };
          this.messageResponse(options);
        }
      }).catch(reason => {
        let options = {
          title : '',
          isHtml : false,
          content : reason,
          size : '',
          showBottonCancel : false,
          textActionCancel : '',
          textAction : 'Aceptar'
        };
        this.messageResponse(options);
      });
    }
  }

  static clickgaleria(){
    //click en la imagen con lupa grande para que popup se despliegue.
    $("#product-image-carousel-container ul li a").eq(0).trigger('click');
  }

  recommendProduct(){
    this.$uibModal.open({
      animation: true,
      template: modalRecommendProduct,
      controller : 'ModalRecommendProductController',
      controllerAs : 'mdCtrl',
      size: '',
      resolve : {
        product  : () => this.productDetail
      }
    });
  }

  clonedAttributesSelected () {
    this.clonedAttributesSelectedLength = 0;

    console.log('clone attribute selected');

    this.clonedProductPrice = '';
    this.showProductPrice = false;
    this.showBottomAddCart = true;
    this.messageClonedProductPrice = '';

    this.clonedFormData.forEach((value, key) => {
      value = value || '';
      if (value) {
        this.clonedAttributesSelectedLength++;
      }
    });

    if (this.productDetail.clonedAttributesDetail.length === this.clonedAttributesSelectedLength) {
      let userId = '';
      try {
        userId = this.shCtrl.globals.currentUser.userId;
      }
      catch (e) {
      }
      this.loadingClonedProductPrice = true;
      let data = {
        'productTemplateId': this.productTemplateCopy.id,
        'attributes': this.clonedFormData,
        'userId': userId
      };
      this.loadingClonedProductPrice = true;
      this.showBottomAddCart = false;
      
      this.ProductDetailService.clonedProductPrice(data).then(response => {
        this.loadingClonedProductPrice = false;
        this.showBottomAddCart = true;
  
        if (!response.error) {
          this.showProductPrice = true;
          this.productDetail.currentPrice = response.data.currentPrice;
          this.productDetail.discountValue = response.data.discountValue;
          this.productDetail.discountPercentage = response.data.discountPercentage;
    
          this.productDetail.clonedId = response.data.clonedId;
    
          this.productDetail.quote = response.data.quote;
          this.productDetail.textLabel = response.data.textLabel;
          this.productDetail.textLabelContinue = response.data.textLabelContinue;
          this.productDetail.textAction = response.data.textAction;
    
          // Replace the template item for the real item
          this.productDetail = response.data.dataItem;
          this.productDetail.clonedAttributesDetail = this.productTemplateCopy.clonedAttributesDetail;
          this.loadedItemFromTemplate = true;
          // Restart pretty photo
          this.initProductImagesViewer();
        }
        else {
          this.messageClonedProductPrice = 'Producto no disponible';
          this.productDetail = angular.copy(this.productTemplateCopy);
          this.loadedItemFromTemplate = false;
    
          // Restart pretty photo
          this.initProductImagesViewer();
        }
      }).catch(reason => {
        console.log('response - error');
        console.log(reason);
        this.loadingClonedProductPrice = false;
        alert('Error al obtener el precio del producto');
      });

    }
    else {
      // Recover the template
      this.productDetail = angular.copy(this.productTemplateCopy);
      this.loadedItemFromTemplate = false;

      this.productDetail.discountValue = 0;
      this.productDetail.discountPercentage = 0;

      // Restart pretty photo
      this.initProductImagesViewer();
    }
    return false;
  }

  increaseProductQuantity () {
    this.productQuantity++;
  }

  getFeaturedProducts(){
    let userId = '';
    try{ userId = this.shCtrl.currentUser.userId; }
    catch(e){}
    this.CatalogService.getFeaturedProducts(userId, 6).then(response => {
      let rellenarList = [];
      response.forEach(item => {
        if(rellenarList.length === 1){
          rellenarList.push(item);
          this.featuredProducts.push(rellenarList);
        }else{
          rellenarList = [];
          rellenarList.push(item);
        }
      });
      // this.featuredProducts = response;
      this.initRelatedProductsCarousel();
    }).catch(reason => {

    });
  }

  initRelatedProductsCarousel(){
    this.$timeout(() => {
      let owlfeatured = $("#featured-items-slider");
      owlfeatured.owlCarousel({
        items: 1,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [979, 1],
        itemsTablet: [768, 1],
        itemsMobile: [479, 1],
        slideSpeed: 400,
        autoPlay: 5000,
        stopOnHover: true,
        navigation: false,
        pagination: false,
        responsive: true,
        mouseDrag: false,
        autoHeight: true
      });

      // Custom Navigation Events Featured
      $("#featured-items-slider-next").click(function(){
        owlfeatured.trigger('owl.next');
      });
      $("#featured-items-slider-prev").click(function(){
        owlfeatured.trigger('owl.prev');
      });
    }, 100);
  }

  decreaseProductQuantity () {
    if (this.productQuantity > 1)
      this.productQuantity--;
  }

  initProductImagesViewer() {
    this.initPluginsProductDetails();
    this.$timeout(() => {
      $('#product-image-carousel-container').find('li:first-child a').mouseover();
    }, 1000);
  }

  openVideo(video){
    let options = {
      video : video,
      propertySrc : 'url'
    };
    this.$uibModal.open({
      animation: true,
      template: modalVideo,
      controller : 'ModalVideoController',
      controllerAs : 'mdCtrl',
      size: '',
      resolve : {
        modalOptions : () => options
      }
    });
  }

  initPluginsProductDetails() {
    this.$timeout(() => {
      $('.related-slider.flexslider').flexslider({
        animation: "slide",
        selector: ".related-list > li",
        controlNav: false, // false
        prevText: '',
        nextText: '',
        smoothHeight: true,
        slideshowSpeed: 7000
      });
      // Pretty Photo
      $("a[data-rel^='prettyPhoto']").prettyPhoto({
        hook: 'data-rel',
        animation_speed: 'fast',
        slideshow: 6000,
        autoplay_slideshow: false,
        show_title: false,
        deeplinking: false,
        social_tools: '',
        overlay_gallery: true,
        theme: 'light_square'
      });
      // Carousel
      let carouselContainer = $('#product-carousel'), productImg = $('#product-image');
      if ($.fn.elastislide) {
        carouselContainer.elastislide({
          orientation: 'vertical',
          minItems: 1
        });
      }
      // Product page zoom plugin settings
      if ($.fn.elevateZoom) {
        productImg.elevateZoom({
          responsive: true, // simple solution for zoom plugin down here // it can cause bugs at resize
          zoomType: (self.mobile || $(window).width() < 768) ? 'inner' : 'lens', // you can use 'inner' or 'window' // change inner and go to product.html page and see zoom plugin differances
          borderColour: '#d0d0d0',
          cursor: "crosshair",
          borderSize: 2,
          lensSize: 140,
          lensOpacity: 1,
          lensColour: 'rgba(255, 255, 255, 0.25)'
        });
        carouselContainer.find('a').on('mouseover', (e) => {
          let ez = $('#product-image').data('elevateZoom'),
            smallImg = $(this).data('image'),
            bigImg = $(this).data('zoom-image');
          ez.swaptheimage(smallImg, bigImg);
          e.preventDefault();
        });
      }
    }, 100);
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

ProductDetailController.$inject = inject;

export default ProductDetailController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/product-detail/product-detail.controller.js
 **/